import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import FeatureDatatables from "component/master/feature/FeatureDatatables";
import FeatureModalForm from "component/master/feature/FeatureModalForm";

function Feature() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feature, setFeature] = useState([]);

  const fetchFeature = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/feature`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data feature");
  
      const data = await response.json();
      setFeature(data.data);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Feature";
      window.scrollTo(0, 0);
      fetchFeature();
  }, []);

  const handleAddFeature = () => {
    setModalMode("add");
    setSelectedFeature(null);
    setIsModalOpen(true);
  }

  const handleEditFeature = (feature) => {
    setModalMode("edit");
    setSelectedFeature(feature);
    setIsModalOpen(true);
  }

  const handleDeleteFeature = async (feature) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Feature',
        text: `Apakah Anda yakin ingin menghapus Feature ${feature.name}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      if (!feature?.feature_id) {
        alert("Feature ID tidak ditemukan");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API}/feature/${feature.feature_id}`
      );

  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Feature berhasil dihapus");
        fetchFeature();
      } else {
        showError(response.data.message || "Gagal menghapus Feature");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Feature");
    }
  };  

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Feature Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddFeature}>
                              </i>
                            </div>
                            <FeatureDatatables data={feature} onEditFeature={handleEditFeature} onDeleteFeature={handleDeleteFeature}/>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <FeatureModalForm mode={modalMode} featureData={selectedFeature} closeModal={closeModal}  onSuccess={fetchFeature}/>
        </div>
      )}

    </div>
  );
}

export default Feature;
